import React, { useEffect, useState } from "react";
import "../../css/empresa_uno/product.css";
import "../../css/table.css";
import { useParams } from "react-router-dom";
import { VariableSizeList } from 'react-window';

import buscar_azul from "../../images/search_azul.png";
import fotoPerfilDefault from "../../images/user.png";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Preloader } from "../../components/Preloader";
import Switch from "@mui/material/Switch";
import { ModalNuevoClienteH } from "../../components/empresa_uno_comp/ModalNuevoClienteH";
import { toast } from "react-toastify";
import { ApiService } from "../../components/ApiService";
import { DataGrid } from "@mui/x-data-grid";
import { Avatar, Stack, Fab, IconButton, Typography, TextField, Button } from "@mui/material";
import Box from "@mui/material/Box";
import Chip from "@mui/joy/Chip";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import Tooltip from "@mui/material/Tooltip";
import Popover from "@mui/material/Popover";
import { useCompanyAssigned } from "../../components/CompanyAssignedContext";
import LupaIcon from "../../svg/lupaIcon";
import TablesMobile from "../../components/empresa/TablesMobile";
import SearchCompany from "./SearchCompany";
import { returnFullURL } from '../../utils/goblaFunctions'
import PowerIcon from '@mui/icons-material/PowerSettingsNew';
import { ImagenesGlobal } from "../../components/global/ImagenesGlobal";

export const ClientesMayoristas = ({ selectedSucursal, permisos, myRoll, loadImageS }) => {
	const { nit, sub_direc } = useParams();
	const [clientes, setClientes] = useState([]);
	const [filteredClientes, setFilteredClientes] = useState([]);
	const [search, setSearch] = useState("");
	const [loading, setLoading] = useState(true);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [editingRow, setEditingRow] = useState(null); // ID de la fila en edición
	const [editedDiscount, setEditedDiscount] = useState(""); // Descuento temporal para edición
	const [isLoading, setIsLoading] = useState(true);
	const [deletingButtons, setDeletingButtons] = useState({});
	const [anchorEl, setAnchorEl] = useState(null);
	const [popoverRow, setPopoverRow] = useState(null);
	const [currentSize, setCurrentSize] = useState(window.innerWidth);

	const [stateMobile, setStateMobile] = useState(false);

	let realAuthCode = "";

	useEffect(() => {
		const handleResize = () => {
			setCurrentSize(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);

		// Cleanup function para quitar el listener cuando el componente se desmonte
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const handleOpenModal = () => {
		setIsModalOpen(true);
	};

	const ApiUrl = process.env.REACT_APP_API_URL;

	const handleCloseModal = () => {
		setIsModalOpen(false);
	};

	useEffect(() => {
		fetchClientesHosming();
	}, [realAuthCode]);

	useEffect(() => {
		if (search.trim() === "") {
			setFilteredClientes(clientes);
		} else {
			const filtered = clientes.filter(
				(cliente) =>
					cliente.fullName.toLowerCase().includes(search.toLowerCase()) || cliente.phone.includes(search)
			);
			setFilteredClientes(filtered);
		}
	}, [search, clientes]);

	const startEditing = (row) => {
		setEditingRow(row.realAuthCode);
		setEditedDiscount(row.discount || 0); // Valor predeterminado si no hay descuento (Quien putas te dijo eu el predeterminado era 20% ???)
	};

	const fetchClientesHosming = async () => {
		setLoading(true);
		try {
			const url = `api/company/clients/discount?key_branch=${selectedSucursal}`;
			const options = { method: "GET" };

			const response = await ApiService.fetchData(url, options);

			if (!response) {
				throw new Error("Error al cargar los clientes hosming");
			}

			const renew_data = response.map((data) => ({
				...data,
				copyDiscount: data.discount,
				copyState: data.state,
				realAuthCode: data.authCode, // ✅ alias que sí existe
				id: data.authCode, // ✅ requerido por DataGrid
			}));

			setClientes(renew_data);
			setFilteredClientes(renew_data);
		} catch (error) {
			console.error("Error al cargar los clientes hosming:", error);
		} finally {
			setLoading(false);
		}
	};


	const saveEditing = (row) => {
		if (editedDiscount < 0 || editedDiscount > 100) return toast.error("Valor de descuento es invalido");

		const updatedClients = clientes.map((client) =>
			client.realAuthCode === row.realAuthCode ? { ...client, discount: editedDiscount } : client
		);

		setClientes(updatedClients);
		setFilteredClientes(updatedClients);
		setEditingRow(null);
	};

	const handleStateClient = (code) => {
		const val_code = String(code).trim();

		if (val_code.length !== 45) return;

		const switch_state = {
			mayorista: "deshabilitado",
			deshabilitado: "mayorista",
		};

		const list_updated = clientes.filter((obj) =>
			obj.realAuthCode === val_code ? (obj.state = switch_state[obj.state]) : obj
		);

		setClientes(list_updated);
		setFilteredClientes(list_updated);
	};
	const handleSaveDiscount = () => {
		if (editedDiscount < 0 || editedDiscount > 100) {
			toast.error("Valor de descuento es inválido");
			return;
		}

		const updatedClients = clientes.map((client) =>
			client.realAuthCode === popoverRow.realAuthCode ? { ...client, discount: editedDiscount } : client
		);

		setClientes(updatedClients);
		setFilteredClientes(updatedClients);
		handleClosePopover();
	};

	const handleDiscountChange = (e) => {
		const text_value = e.target.value;

		if (!isNaN(text_value) && text_value >= 0) {
			setEditedDiscount(text_value);
		}
	};
	const deleteMayorista = async (mayoristaKey) => {
		setDeletingButtons((prevState) => ({
			...prevState,
			[mayoristaKey]: true,
		}));
		try {
			const url = `api/company/clients/delete-discount?key_branch=${selectedSucursal}`;
			const payload = {
				client: mayoristaKey,
				action: false,
			};
			const options = {
				method: "DELETE",
				body: JSON.stringify(payload),
			};

			const response = await ApiService.fetchData(url, options);
			if (response?.code === 200) {
				// Update both state variables to ensure consistency
				const updatedClients = clientes.filter((client) => client.realAuthCode !== mayoristaKey);
				setClientes(updatedClients);
				setFilteredClientes(
					updatedClients.filter(
						(cliente) =>
							search.trim() === "" ||
							cliente.fullName.toLowerCase().includes(search.toLowerCase()) ||
							cliente.phone.includes(search)
					)
				);
				toast.success(response.message);
			}
		} catch (error) {
			toast.error("Error al eliminar el cliente mayorista");
		} finally {
			setDeletingButtons((prevState) => ({
				...prevState,
				[mayoristaKey]: false,
			}));
		}
	};
	const renderColumns = () => {
		const tableColumns = [
			{
				field: "fullName",
				headerName: "Cliente",
				flex: 1,
				minWidth: 150,
			},
			{
				field: "profile",
				headerName: "Foto",
				width: 100,
				align: "center",
				sortable: false,
				headerAlign: "center",
				renderCell: (params) => (
					<Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
						<Avatar
							sx={{ width: 40, height: 40 }}
							src={params.row.profile_url ? `${ApiUrl}${params.row.profile_url}` : fotoPerfilDefault}
							alt={params.row.fullName}
						/>
					</Box>
				),
			},
			{
				field: "date",
				headerName: "Fecha",
				width: 120,
			},
			{
				field: "phone",
				headerName: "Teléfono",
				width: 150,
				renderCell: (params) => (
					<Box>
						{params.row.phone && (
							<Chip
								slotProps={{
									action: {
										component: "a",
										href: `https://wa.me/${params.row.codePhone}${params.row.phone}`,
										target: "_blank",
										rel: "noopener noreferrer",
									},
								}}
								tareg
								variant="soft"
								endDecorator={<WhatsAppIcon fontSize="sm" />}>
								{params.row.phone}
							</Chip>
						)}
					</Box>
				),
			},
			{
				field: "location",
				headerName: "Ubicación",
				width: 150,
			},
		];

		if (["G3R1", "S4A1"].includes(myRoll)) {
			tableColumns.push({
				field: "state",
				headerName: "Mayorista",
				width: 120,
				align: "center",
				headerAlign: "center",
				sortable: false,
				renderCell: (params) => (
					<Switch
						size="small"
						color="primary"
						checked={params.row.state === "mayorista"}
						onChange={() => handleStateClient(params.row.realAuthCode)}
					/>
				),
			});

			tableColumns.push({
				field: "discount",
				headerName: "Descuento",
				width: 150,
				align: "center",
				headerAlign: "center",
				renderCell: (params) => (
					<>
						<Chip
							variant="soft"
							color="warning"
							onClick={(event) => handleOpenPopover(event, params.row)}
							endDecorator={<EditRoundedIcon fontSize="10px" />}>
							% {params.row.discount || 0}
						</Chip>

						<Popover
							open={Boolean(anchorEl) && popoverRow?.realAuthCode === params.row.realAuthCode}
							anchorEl={anchorEl}
							onClose={handleClosePopover}
							anchorOrigin={{
								vertical: "bottom",
								horizontal: "center",
							}}
							transformOrigin={{
								vertical: "top",
								horizontal: "center",
							}}>
							<Box sx={{ p: 2, display: "flex", alignItems: "center", gap: 1 }}>
								<TextField
									type="number"
									size="small"
									label={"Descuento"}
									value={editedDiscount}
									onChange={handleDiscountChange}
									onKeyDown={(e) => {
										if (e.key === "Enter") {
											e.preventDefault();
											handleSaveDiscount();
										}
									}}
									InputProps={{
										endAdornment: <Typography variant="body2">%</Typography>,
										inputProps: { min: 0, max: 100 },
									}}
									sx={{ width: "100px" }}
									autoFocus
								/>
								<IconButton
									variant="contained"
									color="primary"
									size="small"
									onClick={handleSaveDiscount}>
									<CheckRoundedIcon />
								</IconButton>
							</Box>
						</Popover>
					</>
				),
			});

			tableColumns.push({
				field: "actions",
				headerName: "Acciones",
				align: "center",
				headerAlign: "center",
				width: 160,
				renderCell: (params) => {
					const hasChanges =
						params.row.state !== params.row.copyState || params.row.discount !== params.row.copyDiscount;
					const isDeleting = deletingButtons[params.row.realAuthCode] === true;

					return (
						<Stack direction="row" spacing={1} justifyContent="center">
							{
								permisos?.edit && (
									<Tooltip title={hasChanges ? "Guardar Cambios" : "Sin Cambios"}>
										<Fab
											size="small"
											color={hasChanges ? "success" : "default"}
											disabled={!hasChanges}
											onClick={() => saveChanges(params.row)}
											title={hasChanges ? "Habilitado" : "Deshabilitado"}
											sx={{
												width: "32px",
												height: "32px",
												minHeight: "32px",
											}}>
											<CheckRoundedIcon fontSize="small" />
										</Fab>
									</Tooltip>
								)
							}

							{
								permisos?.deleteP && (
									<Tooltip title={"Eliminar"}>
										<IconButton
											size="small"
											onClick={() => deleteMayorista(params.row.realAuthCode)}
											loading={isDeleting}
											disabled={isDeleting}>
											<DeleteRoundedIcon color={"error"} fontSize="small" />
										</IconButton>
									</Tooltip>
								)
							}
						</Stack>
					);
				},
			});
		}
		return tableColumns;
	};
	const columns = renderColumns();

	async function saveChanges(obj) {
		if (obj.state === obj.copyState && obj.discount === obj.copyDiscount) return;

		const body_request = {
			company: realAuthCode,
			client: obj.realAuthCode,
		};

		if (obj.state !== obj.copyState) body_request.action = obj.state === "mayorista" || false;
		if (obj.discount !== obj.copyDiscount)
			body_request.discount = obj.discount > 100 ? 100 : obj.discount < 0 ? 0 : obj.discount;
		const response = await ApiService.fetchData(
			`api/company/clients/update-discount?key_branch=${selectedSucursal}`,
			{
				method: "PUT",
				body: JSON.stringify(body_request),
			}
		);

		const data = await response;

		if (data == null) {
			toast.error("Error de solicitud, Intenta refrescar la página");
		} else {
			toast.success(data.message);
			fetchClientesHosming();
		}
	}
	const handleOpenPopover = (event, row) => {
		setAnchorEl(event.currentTarget);
		setPopoverRow(row);
		setEditedDiscount(row.discount || 0);
	};
	const handleClosePopover = () => {
		setAnchorEl(null);
		setPopoverRow(null);
	};

	const getItemSize = index => {
		const item = filteredClientes?.[index];
		const newSize = typeof item?.height === 'number' ? item.height : 100;
		return newSize + 7; // valor por defecto 100px
	};

	async function editClients(newVal, index, type) {
		if (type == "number" && (newVal < 0 || newVal > 99)) {
			setFilteredClientes((current_val) => current_val);
			return;
		}

		const newArray = [...filteredClientes];
		const body_request = { client: newArray[index]?.authCode, };

		if (type == 'number') {
			newArray[index] = { ...newArray[index], discount: newVal };
			body_request.discount = newVal;
		} else {
			newArray[index] = { ...newArray[index], state: newVal };
			body_request.action = newVal == "mayorista" ? true : false;
		}

		setStateMobile(true);
		const response = await ApiService.fetchData(
			`api/company/clients/update-discount?key_branch=${selectedSucursal}`,
			{
				method: "PUT",
				body: JSON.stringify(body_request),
			}
		);
		setStateMobile(false);

		if (response?.code != 200) {
			toast.error(response.message ?? "Error de solicitud, Intenta refrescar la página");
			setFilteredClientes((current_val) => current_val);
			return;
		}

		setFilteredClientes(newArray);
		toast.success(response?.message);
	}


	const RowList = ({ style, index }) => {
		const objs = filteredClientes[index] ?? null;
		const val_number = objs?.codePhone + objs?.phone;
		let rowSelected = null;

		if (objs) {
			rowSelected = (
				<div style={style}>
					<li key={`mobile-${objs?.profile_url ?? index}`} style={{
						width: '100%',
						border: '1.5px solid var(--theme-company)',
						borderRadius: '40px',
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						padding: '8px',
						gap: '8px',
					}}
					>
						<div style={{
							display: 'flex',
							flexFlow: 'row nowrap',
							gap: '8px',
							justifyContent: 'flex-start',
							width: 'fit-content',
							alignItems: 'center',
						}}
						>
							<div className="profiles-container" style={{ position: 'relative', overflow: 'visible' }}>
								<div style={{
									color: '#fff',
									backgroundColor: 'var(--theme-company)',
									width: '30px',
									height: '30px',
									borderRadius: '50%',
									position: 'absolute',
									top: '-5px',
									right: '-5px',
									fontSize: '10px',
									fontWeight: 'bold',
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center'
								}}>
									<input type="number" className="default-buttons" disabled={stateMobile} style={{ width: '12px', fontWeight: 'bold', color: '#fff' }} defaultValue={objs?.discount}
										onChange={(event) => {
											const val = parseInt(event.target.value, 10);
											if (val > 99) {
												event.target.value = 99;
											}
										}}
										onBlur={(event) => {
											if (objs?.discount != event.target.value) editClients(event.target.value, index, 'number');
										}}
										onKeyDown={(event) => {
											if (event.key === 'Enter') event.target.blur();
										}} />
									<span>%</span>
								</div>
								<ImagenesGlobal
									url={objs?.profile_url}
									type={'profile'}
									alt={objs?.fullName ?? ('Imagen' + index)}
									style={{ borderRadius: '50%' }}
									loadImageS={loadImageS}
								/>
							</div>

							<div className='information-tables' key={objs?.profile_url ?? index}>
								<h3 className='limited-text' style={{ fontSize: '1.1rem', fontWeight: 'bold', WebkitLineClamp: 1 }}>{objs?.fullName}</h3>

								<span style={{ fontSize: '0.8rem', textTransform: 'uppercase' }}>{objs?.date}</span>

								<p className='limited-text' style={{ fontWeight: 'bold', color: '#000', fontSize: '14px' }}>{objs?.location}</p>
							</div>
						</div>

						<div style={{ display: 'flex', gap: '5px' }}>
							<a href={`https://wa.me/${val_number}`} target='_blank' className="default-buttons">
								<WhatsAppIcon style={{ color: "#55BC5B", fontSize: "30px" }} />
							</a>

							<button className="default-buttons" disabled={stateMobile} onClick={() => editClients(objs?.state === "mayorista" ? "deshabilitado" : "mayorista", index, "switch")}>
								<PowerIcon
									style={{
										color: stateMobile ? "#6C757D" : (objs?.state === "mayorista" ? "#02903C" : "#E12728"),
										fontSize: "30px"
									}}
								/>
							</button>
						</div>
					</li >
				</div>
			);
		} else {
			rowSelected = (
				<li style={{ ...style, justifyContent: 'center' }}>
					<span>Sin datos registrados...</span>
				</li>
			);
		}

		return rowSelected;
	}

	const heightConverted = window.innerHeight * 0.64;


	return (
		<>
			<div className="functionality-container">
				<div>
					<h2 style={{ color: 'var(--theme-company)' }}>Clientes Mayoristas</h2>
				</div>

				<SearchCompany theme={'var(--theme-company)'} valor={search} setValor={(event) => setSearch(event.target.value)} placeholder="Mayoristas" />

				{permisos?.insert && (
					<div className="content-btn-add">
						<Button
							variant="contained"
							sx={{ fontWeight: "bold", letterSpacing: "1px", background: 'var(--theme-company)' }}
							onClick={handleOpenModal}>
							Nuevo Mayorista
						</Button>
					</div>
				)}
			</div>

			<div className="datatable-container">
				{loading ? (
					<Preloader />
				) : (
					filteredClientes && (
						currentSize > 480 ? (
							<div className="table-view-pc">
								<div style={{ height: 500, width: "100%" }}>
									<DataGrid
										rows={filteredClientes}
										columns={columns}
										getRowId={(row) => row.id}
										pageSize={10}
										disableColumnMenu={true}
										rowsPerPageOptions={[5, 10, 25]}
										hideFooterSelectedRowCount={true}
										disableRowSelectionOnClick={true}
										disableSelectionOnClick
										localeText={{
											MuiTablePagination: {
												labelRowsPerPage: "Filas por pagina:",
												labelDisplayedRows: ({ from, to, count }) =>
													`${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
											},
										}}
										sx={{
											"& .MuiDataGrid-cell": {
												display: "flex",
												alignItems: "center",
											},
											"& .MuiDataGrid-columnHeader": {
												backgroundColor: 'var(--theme-company)',
												color: "#ffffff",
												fontWeight: "bold",
											},
											"& .MuiDataGrid-columnHeader:hover": {
												backgroundColor: 'var(--theme-company)',
											},
										}}
									/>
								</div>
							</div>
						) : (
							<VariableSizeList
								height={heightConverted}
								itemCount={(filteredClientes ?? []).length}
								itemSize={getItemSize}
								width={'100%'}
								outerElementType={CustomUL}
							>
								{RowList}
							</VariableSizeList>
						)
					)
				)}
			</div >

			<ModalNuevoClienteH
				isOpen={isModalOpen}
				onClose={handleCloseModal}
				reset_data={fetchClientesHosming}
				keyBranch={selectedSucursal}
			/>
		</>
	);
};

const CustomUL = React.forwardRef(({ style, ...rest }, ref) => (
	<ul ref={ref} {...rest} style={{ ...style, overflow: 'auto' }} />
));